'use client';

import {Box, styled} from '@mui/material';
import {StyledSectionContainer} from '@/components/sections/shared/Section.styles';

export const StyledInformationMediaSectionContainer = styled(StyledSectionContainer)(({theme}) => ({
  color: theme.palette.text.dark,
}));

export const StyledInformationMediaSectionContentContainer = styled(Box)(({theme}) => ({
  width: '100%',
  color: theme.palette.text.dark,
  display: 'flex',
  gap: theme.spacing(4),
  justifyContent: 'center',
  alignItems: 'start',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  }
}));

export const StyledInformationMediaBreadTextContainer = styled(Box)(({theme}) => ({
  flex: 1,
  maxWidth: theme.breakpoints.values.readableText,
}));

export const StyledInformationMediaMediaContainer = styled(Box)(({theme}) => ({
  borderRadius: theme.shape.borderRadiusLg,
  // necessary for next/image with `fill` to size itself correctly
  position: 'relative',
  width: '100%',
  flex: 1,
  // give a sensible default height; you can change to an aspect ratio if desired
  overflow: 'hidden',
  aspectRatio: '16 / 9',
}));